/* eslint-disable import/prefer-default-export */
import {
  DashboardDateRangePickerTypes,
  DashboardDateRangePickerTypesEnum
} from '@features/dashboard/constants';
import { getSelectedDateRange } from '@features/dashboard/helper';
import { DateRangeType } from '@features/dashboard/types';
import { getStartAndPresentDateOfCurrentMonth } from '@utils/date';

export const mapDateRangeOptions = () =>
  DashboardDateRangePickerTypes.map((option) => ({
    id: option.key,
    label: option.label,
    value: option.key,
    type:
      option.key === DashboardDateRangePickerTypesEnum.custom
        ? 'date'
        : undefined
  }));

export const getDateRangeForType = (
  type: string,
  customDateRange: any
): DateRangeType => {
  let dateRange;

  switch (type) {
    case DashboardDateRangePickerTypesEnum.thisMonth:
      dateRange = getStartAndPresentDateOfCurrentMonth();
      break;

    case DashboardDateRangePickerTypesEnum.lastMonth:
      dateRange = getStartAndPresentDateOfCurrentMonth();
      break;

    case DashboardDateRangePickerTypesEnum.custom:
      if (
        customDateRange &&
        customDateRange.startDate &&
        customDateRange.endDate
      ) {
        const result = getSelectedDateRange({
          startDate: customDateRange.startDate,
          endDate: customDateRange.endDate
        });
        return result;
      }
      return {
        startDate: '',
        endDate: ''
      };

    default:
      // Return empty strings for default case
      return {
        startDate: '',
        endDate: ''
      };
  }

  return getSelectedDateRange(dateRange);
};
